import { render, staticRenderFns } from "./NavSection.vue?vue&type=template&id=37846df1&"
import script from "./NavSection.vue?vue&type=script&lang=ts&"
export * from "./NavSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports